<template>
  <div class="layout-base-list">
    <div
      v-if="$slots.background"
      class="layout-base-list__background"
    >
      <slot name="background" />
    </div>
    <div v-if="$slots.navigation" class="layout-base-list__navigation">
      <slot name="navigation" />
    </div>
    <main class="layout-base-list__content">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
onMounted(() => {
  document.documentElement.style.overflow = 'hidden'
  document.body.style.overflow = 'hidden'
})

onUnmounted(() => {
  document.documentElement.style.overflow = ''
  document.body.style.overflow = ''
})
</script>

<style lang="scss" scoped>
.layout-base-list {
  background-color: var(--color-surface-placeholder);
  display: flex;
  flex-direction: column;
  height: 100dvh;

  &__background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__navigation {
    @include container;

    min-height: 84px;
  }

  &__content {
    @include container;

    height: 100%;
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-top: rem(32px);
    padding-bottom: rem(32px);

    @include bp-media('xs', 'sm') {
      padding-bottom: rem(26px);
    }

    @include bp-media('xs') {
      padding-bottom: rem(16px);
    }

    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      display: block;
      background: var(--color-surface-placeholder);
    }

    &::-webkit-scrollbar-thumb {
      background: var(--color-surface-primary);
      border-radius: 5px;
    }
  }

  &__navigation + &__content {
    padding-top: rem(12px);
  }
}
</style>
